/**
 * Payment-provider flag facade.
 *
 * The GigMi relaunch swaps payments from AeroPay/Everee to Stripe. The whole
 * migration is gated on a single build-time env flag so the app is releasable at
 * every step and cutover/rollback is one env change + rebuild. Branch on
 * `isStripe()` at the payment entry points (subscription, contract charge,
 * receive/payouts, add-card); both branches end in the same downstream nav/status
 * action so routing stays provider-agnostic.
 *
 * Read from `process.env` (build-time constant) — never from Redux.
 */
export const PAYMENT_PROVIDER =
  process.env.REACT_APP_PAYMENT_PROVIDER || "aeropay"; // 'aeropay' | 'stripe'

export const isStripe = () => PAYMENT_PROVIDER === "stripe";

export const isAeropay = () => PAYMENT_PROVIDER === "aeropay";
